import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { ProductsByStatusDto } from 'src/store/products/product';

type Props = {
  productsByStatus: Nullable<ProductsByStatusDto>;
};

export const ProductsStatusChart: React.FC<Props> = ({ productsByStatus }) => {
  const { t } = useTranslation();

  const [series, setSeries] = useState<number[]>([100]);
  const [labels, setLabels] = useState<string[]>(['Empty']);
  const [colors, setColors] = useState<string[]>(['var(--primary-color8)']);

  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
      height: 300
    },
    labels: labels,
    legend: {
      position: 'right'
    },
    colors: colors
  };

  useEffect(() => {
    if (productsByStatus) {
      const {
        accepted,
        acceptedWithDeviation,
        inProduction
      } = productsByStatus;
      if (accepted || acceptedWithDeviation || inProduction) {
        setColors([
          'var(--green-status-color)',
          'var(--yellow-status-color)',
          'var(--blue)'
        ]);
        setLabels([
          t('productStatus.accepted'),
          t('productStatus.acceptedWithDeviation'),
          t('productStatus.inProduction')
        ]);
        setSeries([accepted, acceptedWithDeviation, inProduction]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsByStatus]);

  return (
    <Chart
      type="donut"
      options={chartOptions}
      series={series}
      height={300}
      width={500}
    />
  );
};
